export default "__VITE_ASSET__4c2a23d7__"